import React from 'react';

type Props = {
  onClose?: () => void
}

export default function CloseButton({onClose}: Props) {
  return (
    <button type="button" onClick={onClose}
      className="bg-white rounded-md text-gray hover:text-black focus:outline-none">
      <span className="sr-only">Close</span>
      <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
        stroke="currentColor" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
  );
}
